<template>
  <div class="header-wrapper">
    <div class="header">
      <div class="logo-and-action-menu">
        <RouterLink
          class="brand-logo"
          :to="{ name: 'Cockpit' }"
        >
          <img
            :src="brandLogo"
            height="25.5"
          >
        </RouterLink>
        <ActionMenu class="action-menu" />
      </div>
      <Notification />
      <div class="right-content">
        <NotificationPopover />
        <Settings />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import brandLogo from '@/assets/brand_logo.svg';
import ActionMenu from '@/components/organisms/user/ActionMenu.vue';
import Notification from '@/components/organisms/user/Notification.vue';
import Settings from '@/components/organisms/user/Settings.vue';
import NotificationPopover from './NotificationPopover.vue';
</script>

<style lang="scss" scoped>
  .header-wrapper {
    @include m-fixed-width(0px);
    transition: $transition-base;
    position: relative;

    .header {
      @include m-fixed-width(100vw);
      @include m-fixed-height(50px);
      position: fixed;
      background-color: $bgcolor-white;
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 9;
      box-shadow: 0 2px 6px 0 $shadowcolor-base;

      .action-menu {
        margin-left: 20px;
      }
    }
  }

  .brand-logo {
    margin-top: 6px;
    margin-left: 22px;
  }

  .right-content {
    @include m-flex-align-center;
    @include m-flex-justify-right;
    flex-wrap: nowrap;
  }

  .logo-and-action-menu {
    display: flex;
    align-items: center;
  }
</style>
